<template>
   <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div v-else>
          <!-- Keep-alive should wrap <router-view /> -->
         
    <div class="homepage d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
            <div class="d-flex align-items-center">
         
              <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span> &nbsp; &nbsp;

                  <span>
                     <h4 class="text-white">{{language?.menu_product}}</h4>
                  </span>
         
            
               <div class="d-flex align-items-center gap-2 ms-auto">
                
                 <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas" data-bs-target="#product"
                  aria-controls="product">
                  <b class="bg-dark bg-opacity-75 rounded-circle user-icon">
                  <i class="bi bi-plus  d-flex m-1 h4 text-white"></i>
                  </b>
                  </a>
               </div>
            </div>
            



         </div>





         
    
         <!-- body -->
         <div class="my-auto overflow-auto vh-100">
           

          <div class="card-header d-flex justify-content-center p-2">
            <div class="col-12">
              <label for="products" class="form-label">{{language?.search_products}}</label>
              <input type="text"   v-model="search_txt" class="form-control">
              <!-- <select class="form-select form-select-sm" id="products" ref="products" v-model="cost.products">
                  <option value=""></option>
                  <option value="All">ALL</option>
                  <option v-for="(item, index) in productsList" :key="index" :value="item.id">{{ item.name }}</option>
              </select> -->
          </div>
          
            </div>



          
            <!-- Top Evets -->
            <div class="pt-3 bg_card">
               
               <div class="row">
                  <!-- 1st item -->
                  <div class="">
                    
                     <div class="card  border-1 overflow-hidden " v-for="(product,i) in products">
                        
                             <div class="card-body p-2">
                                <div class="row g-2">

                                  <!-- Image -->
                                  <div class="col-auto" v-if="userRow.image_upload == 1">
                                    <img
                                      :src="'https://laundry.dktsoft.in/public/uploads/productimg/' + product.prdimage"
                                      style="width:45px;height:45px;object-fit:cover;"
                                    >
                                  </div>

                                  <!-- Name + Description -->
                                  <div class="col ps-1">
                                    <div class="fw-bold small m-0 p-0">
                                      {{ product.name }}
                                    </div>
                                    <div class="text-muted small m-0 p-0">
                                      {{ product.description }}
                                    </div>
                                  </div>

                                </div>
                              </div>



                            
                        <div
                           class="card-footer ">
                           <div>
                              <span class="badge bg-success" @click="editProduct(product)"><i class="bi bi-pen"></i> &nbsp;{{language?.edit}}</span> &nbsp; &nbsp; 
                              <span class="badge bg-danger" @click="deleteProduct(product.id)"><i class="bi bi-trash"></i> &nbsp; {{language?.delete}}</span> &nbsp; &nbsp;
                              <span class="badge bg-success" @click="addcart(product.id)"><i class="bi bi-plus-square"></i> &nbsp;{{language?.manage}}</span> 
                           </div>
                            
                        </div>

                     </div> 
                  </div> 
                  
               </div> 
            </div>

       


 


  
         </div>
         
                <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="product" aria-labelledby="productLabel">
                <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
                    <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5 text-white"></i></a>
                    <h6 class="offcanvas-title text-white m-0" id="productLabel">{{language?.create_new_product}}</h6>
                </div>
                <div class="offcanvas-body">
                
                
                    <div class="mb-3">
                        <label for="name" class="form-label">{{language?.product_name}}</label>
                        <input type="text" id="name" v-model="product.name" class="form-control" required>
                    </div>

                    <div class="mb-3">
                     <label for="description" class="form-label">{{language?.product_description}}</label>
                     <input type="text" id="description" v-model="product.description" class="form-control" required>
                 </div>


                <div class="mb-1" v-if="userRow?.image_upload == 1">
                    <label  class="form-label" for="img_upload_here">{{language?.Image}}<br>
                    <input type="file" id="img_upload_here" style="display: none;" @change="eventFileUpload" class="form-control" required>
                    <!-- <img src="../assets/upload_image.jpg" style="             height: 50px; "/> -->
                    <img v-if="imagePreview" :src="imagePreview" style="max-width: 150px; border: 2px solid #000; border-radius: 5px;">
                    </label>
                </div>
        
                    <div class="d-flex gap-2">
                    <button class="btn btn-primary w-100" @click="addproduct">{{language?.save}}</button>
                    <button class="btn btn-secondary w-50" @click="goprevious">{{language?.back}}</button>
                  </div>
         </div>
      </div>


<!-- second  -->

                <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="cost" aria-labelledby="costLabel">
                  <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
                      <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5 text-white"></i></a>
                      <h6 class="offcanvas-title text-white m-0" id="costLabel">{{language?.service_link}}</h6>
                  </div>
                  <div class="offcanvas-body">
                  
                  
                  
                            <div class="col-md-3">
                              <label for="services" class="form-label">{{language?.search_services}} <small><router-link to="/services"> Manage Services</router-link></small></label>
                              <select class="form-select form-select-sm" id="services" ref="services" v-model="cost.servicesid">
                                  <option value=""></option>
                                  <option v-for="(item, index) in servicesList" :key="index" :value="item.id">{{ item.name }}</option>
                              </select>
                            </div>
                            

                      <div class="mb-3">
                      <label for="cost" class="form-label">{{language?.amount}}</label>
                      <input type="number" id="cost" v-model="cost.costs" class="form-control" required>
                  </div>


                      
                      <button class="btn btn-primary w-100 " @click="addcost">Save</button>

                      
                      <div class="card  border-1 overflow-hidden " v-for="(cost,i) in filteredproductsCostList">
                        
                        <div class="card-body">
                          <!-- <b>{{branch.name}}</b> -->
                          <div><i class="bi bi-bag"></i> <strong>{{ cost.service_name }}</strong></div>
                          <div><i class="bi bi-currency-rupee"></i>{{cost.cost}}</div>
                        </div> 
                    
                    <div
                      class="card-footer ">
                      <div>
                      <span class="badge bg-success" @click="editCost(cost)"><i class="bi bi-plus-square"></i> &nbsp;Edit</span> &nbsp; &nbsp;                           
                        </div>
                      </div>

                </div>
                  
                </div>
                </div>

<!-- second -->







      </div>
    </div>
</template>
  
<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'Branch',
  components: { 
  },
  mounted() { 
   //  this.fetchWeather();
   this.getProducts(); // Call the method here
    
},
watch: {
    search_txt(newVal) {
      this.products = this.productsList.filter((item) =>
        item.name.toLowerCase().includes(newVal.toLowerCase())
      );
    },
  },
  data() {
    return { 
      imagePreview:'',
      loading:false,
      error:null,
      isUserLogged:false,
      user_details:[],
      servicesList:[],
      productsCostLis:[],
      search_txt:'',
      filteredproductsCostList:[],
      language:this.getLocalStorageArray('lang'),
      filteredproductsList:[],
      product:{
         name:'',
         description:'',
         prdimage:'',
      },
      cost:{
        costs:'',
        servicesid:'',
        productid:'',
      },
      products:[], 
      branch_name:'',
      userRow:[],

    }
  },
  methods:{
    initializeHomeContent(){
    

    },

    goBack() {
          
                this.$router.go(-1);
        },
        goprevious() {
          
          this.$router.go("/products");
  },
 
 
 
    async getProducts() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getProducts").then((response) => {
               self.products=response.data.product;
               self.productsList=response.data.productsLists;
               self.filteredproductsList=self.productsList;
               self.productsCostList=response.data.cost;
               self.servicesList=response.data.servicesLists;
               self.userRow=response.data.userRow;
               self.language=response.data.language;
               localStorage.setItem('lang',response.data.language);
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 





      addproduct() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("addproduct",self.product,
      {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
            ).then((response) => {
              
                        self.products=response.data.product;
                        self.userRow=response.data.userRow;
                        self.$swal.fire(response.data.message);
                        if(response.data.success)
                        {
                            self.product={ name:'',         description:''};
                        }
                      window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("product")).hide();
                      

               
        
                }).then(() => {
                    self.initializeHomeContent();
                }).catch((err) => {
                    
                });;
                

                } catch (err) {
                this.error = err.response?.data?.message || "Login failed. Please try again.";
                } finally {
                this.loading = false;
                }
            }, 


      editProduct(editProduct) {
         window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("product")).show();
         this.product=editProduct;
      }, 

      addcart(product_id) {
                this.filteredproductsCostList = this.productsCostList.filter((item) =>
                  item.productid==product_id
                );

                
                this.cost.productid = product_id; // Set the productid dynamically
                window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("cost")).show();
            // this.cost=editcost;
            }, 



      deleteProduct(id = "") {
    this.loading = true;
    this.error = null;

    try {
        var self = this;

        this.$swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post("deleteProduct", { id: id }).then((response) => {
                    self.products=response.data.product;
                    self.$swal.fire(response.data.message);
                    
                    if (response.data.success) {
                        window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("product")).hide();
                    }
                }).then(() => {
                    self.initializeHomeContent();
                }).catch((err) => {
                    self.$swal.fire("Error!", "Something went wrong.", "error");
                });
            }
        });

    } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
    } finally {
        this.loading = false;
    }
},

editCost(_cost) {
              this.cost.id=_cost.id;
              this.cost.costs=_cost.cost;
              this.cost.servicesid=_cost.serviceid;
            //   alert(this.cost.servicesid);
            //   $(this.$refs.services).val(this.cost.servicesid).trigger("change");
              // window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("cost")).show();
              
          }, 



          addcost() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("addcost",self.cost).then((response) => {
              
                          self.productsList=response.data.productsLists;
                          self.filteredproductsList=self.productsList;

                           
                          self.productsCostList=response.data.cost;
                          self.servicesList=response.data.servicesLists;
                     
                        self.$swal.fire(response.data.message);
                        if(response.data.success)
                        {
                            let product_id=response.data.productid;
                            self.cost={ costs:'', servicesid:''};
                             self.filteredproductsCostList = self.productsCostList.filter((item) =>
                              item.productid==product_id
                            );
            
                            
                            self.cost.productid = product_id; 
                        }
                        
                        
                        
                    //   window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("cost")).hide();
                      

               
        
                }).then(() => {
                    self.initializeHomeContent();
                }).catch((err) => {
                    
                });;
                

                } catch (err) {
                this.error = err.response?.data?.message || "Login failed. Please try again.";
                } finally {
                this.loading = false;
                }
            }, 

     

            getLocalStorageArray(key) {
        let data = localStorage?.getItem(key);
        try {
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.error("Error parsing localStorage data", e);
            return [];
        }
    },

      eventFileUpload(event) {
                this.product.prdimage = event.target.files[0]; // Store the selected file
                const file = event.target.files[0]; // Correctly define 'file'
                    if (file) {
                      this.product.prdimage = file; // Store the selected file
                      this.imagePreview = URL.createObjectURL(file); // Create image preview
                    }
            },




  }
}






</script>
